import "foundation-sites";
import "./images.js";
import "./vue/bootstrap.js";

import $ from "jquery";
import loadScreen from "./elements/load-screen.js";
import navbar from "./elements/navbar.js";
import projectSlider from "./elements/project-slider.js";
import map from "./elements/map.js";
import tabbedContent from "./elements/tabbed-content.js";
import print from "./elements/print.js";
import clipboard from "./elements/clipboard.js";
import populateProjectInfo from "./elements/populate-project-info.js";
import partenaireSlider from "./elements/partenaire-slider.js";
import scrollReveal from "./elements/scroll-reveal.js";
import slider from "./blocks/block-slider.js";
import conseils from "./blocks/block-conseils.js";
import contact from "./blocks/block-contact.js";
import vueBoostrap from "./vue/bootstrap.js";
import votreEtudeTabs from "./elements/votre-etude-tabs.js";
import subBlockProject from "./blocks/sub-block-projects.js";
import blockProject from "./blocks/block-projects.js";

/* eslint-disable */
__webpack_public_path__ = themeURI;
/* eslint-enable */

window.$ = $;
window.jQuery = $;

$(document).ready(() => {
  $(document).foundation();
  // scrollReveal.enable()
  navbar.enable();
  slider.enable();
  map.enable();
  projectSlider.enable();
  tabbedContent.enable();
  print.enable();
  clipboard.enable();
  populateProjectInfo.enable();
  partenaireSlider.enable();
  conseils.enable();
  contact.enable();
  vueBoostrap.enable();
  votreEtudeTabs.enable();
  subBlockProject.enable();
  blockProject.enable();
  loadScreen.enable();
});



// WEBPACK FOOTER //
// ./src/js/main.js